export default __webpack_public_path__ + "static/media/Titel_image_prison_break.97a8a7d3.jpg";